import { useForm, Controller } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useGetSystemGroupQuery, useAddGroupSubscriberMutation } from '../../api/groupApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import PhoneField from '../../components/PhoneField/PhoneField';
import { digitsToPhone } from '../../utils/phone';
import { CHANNEL_OPTIONS } from '../../utils/channels';
import buttons from '../../styles/shared/buttons.module.css';

export default function SystemGroupSubscriberCreatePage() {
  const { id: groupId } = useParams();
  const navigate = useNavigate();
  const showToast = useToast();

  const { data: group } = useGetSystemGroupQuery(groupId);
  const [addSubscriber, { isLoading: isCreating }] = useAddGroupSubscriberMutation();

  const { control, handleSubmit, watch } = useForm({
    defaultValues: { email: '', phone: '', channel: 'email' },
  });
  const channel = watch('channel');

  const onCreate = async (data) => {
    try {
      await addSubscriber({
        groupId,
        email: data.email.trim().toLowerCase(),
        phone: digitsToPhone(data.phone),
        channel: data.channel,
      }).unwrap();
      showToast('success', 'Subscribers', 'Subscriber added.');
      navigate(`/admin/system-groups/${groupId}/subscribers`);
    } catch (err) {
      showToast('error', 'Subscribers', errMsg(err, 'Could not add subscriber.'));
    }
  };

  return (
    <EntityFormPage
      title={`Add subscriber${group ? ` — ${group.name}` : ''}`}
      backTo={`/admin/system-groups/${groupId}/subscribers`}
    >
      <form onSubmit={handleSubmit(onCreate)}>
        <Controller
          name="email"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Email</label>
              <InputText id={field.name} type="email" className="w-full mb-3" {...field} />
            </div>
          )}
        />

        <Controller
          name="channel"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label htmlFor={field.name}>Channel</label>
              <Dropdown
                id={field.name}
                value={field.value}
                onChange={(e) => field.onChange(e.value)}
                options={CHANNEL_OPTIONS}
                className="w-full mb-3"
              />
            </div>
          )}
        />

        {channel === 'text' && <PhoneField control={control} required />}

        <Button type="submit" label="Save" className={buttons.saveBtn} loading={isCreating} />
      </form>
    </EntityFormPage>
  );
}
